import { getAssetLoadError } from "../../utils/getAssetLoadError";
import { useMemo } from "react";
import { trpc } from "../trpc";

export function useQuerySupportedAssets() {
  const query = trpc.folder.getSupportedAssets.useQuery(undefined, {
    staleTime: 600_000, // 10 minute stale time
    gcTime: 600_000, // 10 minute gc time
  });

  const { data, isLoading } = query;
  const supportedAssets = useMemo(
    () => data?.supportedTypes || ([] as string[]),
    [data],
  );

  return {
    loadError: getAssetLoadError(query),
    supportedAssets,
    isLoading,
  };
}
